import React from 'react';

import { useApp } from '../store/AppContext';
import YearImportResult from './YearImportResult';

export default function YearImportModal() {
  const { yearImportModal } = useApp();
  return (
    <div
      className="modal w-[940px] max-w-[96vw] max-h-[92vh] flex flex-col"
      onClick={(e) => e.stopPropagation()}
    >
      {yearImportModal.loading && (
        <div className="p-[24px] text-center">
          <div className="text-[13px] text-grey-dark mb-[16px]">
            Import en cours — {yearImportModal.current}
          </div>
          <div className="h-[6px] bg-[#f0ede8] rounded-[3px] overflow-hidden mb-[8px]">
            <div
              className="h-full rounded-[3px] bg-teal [transition:width_.3s]"
              style={{
                width: `${yearImportModal.total > 0 ? Math.round((yearImportModal.done / yearImportModal.total) * 100) : 0}%`,
              }}
            />
          </div>
          <div className="text-[11px] text-grey-light">
            {yearImportModal.done} / {yearImportModal.total} projets traités
          </div>
        </div>
      )}

      <YearImportResult />
    </div>
  );
}
